import { Typography } from '@repo/design-system-cf/components/typography'
import type { Project } from '../page-client'
import { IconSignpost, IconNorthEast } from '@repo/design-system-cf/components/icons'
import { Button } from '@repo/design-system-cf/components/button'
import { Link } from '@repo/web-ui/components/link'
import { NEXT_PUBLIC_CF_URL } from '@web/utils/env'
import { useFeedRoute } from '../contexts/feed-route-context'

export function ProjectPostTutorialCard({ project }: { project: Project }) {
  const { basePath } = useFeedRoute()
  const postUrl = `${NEXT_PUBLIC_CF_URL}${basePath}/${project.postSlug}/tutorial/`
  return (
    <Link
      href={postUrl}
      target="_blank"
      className="transition-shadow bg-cf-purple-50 duration-300 mt-3 cursor-pointer flex flex-1 p-4 border-cf-transparent-grey-1000-12 w-full border rounded-[12px] gap-3 flex-col hover:shadow-[0px_2px_4px_2px_#1313151F,0px_1px_1px_0px_#1313151F] active:shadow-none focus-visible:outline-[#2D52BE]"
    >
      <div className="flex sm:justify-between sm:items-center flex-col sm:flex-row gap-4">
        <div className="flex gap-3 items-center">
          <div className="flex justify-center items-center size-9 bg-cf-purple-900 rounded-full">
            <IconSignpost className="text-cf-white size-6" />
          </div>
          <div>
            <p className="text-16 leading-6 sm:text-18 sm:leading-[26px] font-bold">
              View tutorial
            </p>
            <Typography variant="body-01">Learn how to make this</Typography>
          </div>
        </div>
        <Button variant="secondary" iconRight={<IconNorthEast />} className="bg-transparent">
          View tutorial
        </Button>
      </div>
    </Link>
  )
}
